import type {z} from "zod";

import {createValidationIssue} from "@project/i18n";
import {CreateServiceBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {serviceFieldLabelIds, serviceValidationMessages} from "../../../messages/services.messages";

const [simple, composite] = CreateServiceBody.options;
const fields = {
  code: requiredStringSchema(simple.shape.code, serviceFieldLabelIds.code),
  name: requiredStringSchema(simple.shape.name, serviceFieldLabelIds.name),
  internalDescription: requiredStringSchema(
    simple.shape.internalDescription,
    serviceFieldLabelIds.internalDescription,
  ),
  priceProtected: simple.shape.priceProtected,
  billingUnit: simple.shape.billingUnit,
};
const simpleFields = zod.object({
  ...fields,
  compositionKind: simple.shape.compositionKind,
  initialSupplierId: requiredStringSchema(
    simple.shape.initialSupplierId,
    serviceFieldLabelIds.initialSupplierId,
  ),
});
const compositeFields = zod.object({
  ...fields,
  compositionKind: composite.shape.compositionKind,
  components: composite.shape.components,
});

export const createServiceFormSchema = zod.union([
  simpleFields,
  compositeFields.superRefine(({components}, ctx) => {
    if (components.length === 1 && components[0]?.quantity === 1) {
      ctx.addIssue({
        ...createValidationIssue({id: serviceValidationMessages.compositeRequired.id}),
        path: ["components"],
      });
    }
  }),
]);
export type CreateServiceFormPayload = z.output<typeof createServiceFormSchema>;

export const draftCreateServiceFormSchema = zod
  .object({
    ...fields,
    compositionKind: zod.union([simple.shape.compositionKind, composite.shape.compositionKind]),
    initialSupplierId: simple.shape.initialSupplierId,
    components: composite.shape.components,
  })
  .partial();
export type DraftCreateServiceFormPayload = z.output<typeof draftCreateServiceFormSchema>;
